import L from 'leaflet'
import Vue from 'vue'

import {
  CALC_ACTION,
  EXPANSION_ZOOM,
  GET_CLUSTER_POINTS,
  getFeatureId,
  LOAD_ACTION,
  MAP_GRID,
  PURGE_CACHE,
} from './objectsSuperclasterUtils'
import ObjectsSuperclasterWorker from 'worker-loader!./ObjectsSuperclasterWorker.js'
import { createDevBlock, putPointToBlock } from './debug'
import deepCopy from '../../deepCopy'
import { REGION_CONFIG } from '@/config/regions'
// import { bboxClip } from '@turf/turf'

let queueCounter = queueCounter || 0
const isDebug = false
const LOW_LEVEL_DANGER_WASTE_KEY = '11'
const MSN_TYPES = {
  accumulator: 'Аккумуляторные батарейки',
  mercurial: 'Ртутные отходы',
}

class ObjectsSupeclasterGroup {
  popupCreator = null
  markerCreator = null
  vm = null
  _map = null
  _geoJsonLayer = null
  opts = {}
  _data = {}
  _layers = {}
  cachedIcons = {}
  layerConfig = null
  workerDataLoaded = false
  prevShownState = ''
  openedClusters = []
  maxMarkersInClusterOnOnePoint = 1000
  splitClusterMarkersToSubcluster = true
  openedSubClusters = []

  constructor(
    map,
    config,
    opts = {
      vm: null,
      markerCreator: null,
      popupCreator: null,
      subLayerClass: null,
    }
  ) {
    this.opts = opts
    this.vm = opts.vm
    this.popupCreator = opts.popupCreator
    this.markerCreator = opts.markerCreator
    this._map = map
    this.layerConfig = config.layer
    this.groups = config.groups
    this.checkbox = config.checkbox
    this.initWorker()
    this.createSubgroups(config)
    this.createGeoJsonLayer()
    this._map.on('moveend', () => this.onMoveend())
  }

  initWorker() {
    // fix: error in ie 9 on create worker
    try {
      this.worker = new ObjectsSuperclasterWorker()
    } catch (e) {
      console.error('cant create ObjectsSuperclasterWorker ', e)
      this.worker = {}
      return
    }
    // timeout need for spinner
    this.worker.onmessage = (e) => {
      this.updateBarState()
      setTimeout(() => {
        this.onWorker(e)
      }, 0)
    }
    this.worker.onerror = (e) => {
      console.error(e)
      this.vm.$e.errorBox(e)
      this.mutateCounter(-1)
    }
  }

  onMoveend() {
    if (this.hasShown() === true) {
      this.recaclData()
    }
  }

  onWorker(e) {
    switch (e.data.action) {
      case LOAD_ACTION:
        this.workerDataLoaded = true
        this.recaclData()
        this.mutateCounter(-1)
        break
      case CALC_ACTION:
        this.updateJsonLayer(e.data.geoJson)
        this.appendClusterPoints(
          e.data.openedMarkers,
          e.data.openedClusterId,
          e.data.openedCluster
        )
        this.mutateCounter(-1)
        break
      case EXPANSION_ZOOM:
        this._map.setView(e.data.latlng, e.data.zoom)
        this.mutateCounter(-1)
        break
      case GET_CLUSTER_POINTS:
        this.appendClusterPoints(
          e.data.features,
          e.data.openedClusterId,
          e.data.openedCluster
        )
        this.mutateCounter(-1)
        break
    }
  }

  mutateCounter(val = 0) {
    queueCounter = queueCounter + val
    this.updateBarState()
  }

  updateBarState() {
    if (queueCounter > 0) {
      this.vm.$bar.startOrContinue()
      if (this.vm.$bar.percent < 10) {
        this.vm.$bar.set(10)
      }
    } else {
      this.vm.$bar.finish()
    }
  }

  sendMessage(action, data = {}) {
    data.action = action
    try {
      this.worker.postMessage(data)
    } catch (e) {
      console.error(e)
      this.vm.$e.errorBox(e)
    }
    // skip bar on purge for opened card edit reason
    if (action === PURGE_CACHE) {
      return
    }
    this.mutateCounter(1)
    // state bar keeper
    // used if user go by link layers=gs,org,med,ind,gsk,apartmentBuildi
    setTimeout(() => this.updateBarState(), 500)
  }

  isMaxMapZoom() {
    return this._map.getZoom() >= this._map.getMaxZoom()
  }

  appendClusterPoints(clusterFeatures, openedClusterId, openedCluster) {
    if (clusterFeatures.length > 0) {
      let features = []
      if (
        this.splitClusterMarkersToSubcluster === true &&
        clusterFeatures.length > this.maxMarkersInClusterOnOnePoint
      ) {
        let subClusters = []
        let coordinates = clusterFeatures[0].geometry.coordinates
        let subClusterCount = Math.ceil(
          clusterFeatures.length / this.maxMarkersInClusterOnOnePoint
        )
        for (let i = 0; i < subClusterCount; i++) {
          let featuresInSubCluster = clusterFeatures.slice(
            i * this.maxMarkersInClusterOnOnePoint,
            (i + 1) * this.maxMarkersInClusterOnOnePoint
          )
          let subCluster = {
            type: 'Feature',
            properties: {
              cluster_id: openedClusterId,
              subClusterId: `${openedClusterId}_${i}`,
              subCluster: true,
              point_count: featuresInSubCluster.length,
              cluster: true,
              features: featuresInSubCluster,
            },
            geometry: {
              type: 'Point',
              coordinates,
            },
          }
          subClusters.push(subCluster)
        }
        features = this.createSpiral(
          subClusters,
          openedClusterId,
          openedCluster,
          { spiderfyDistanceMultiplier: 1.33 }
        )
        // check for opened marker by link
        for (let i = 0; i < subClusters.length; i++) {
          let len = subClusters[i].properties.features.length
          for (let j = 0; j < len; j++) {
            if (
              this.popupIsOpened(
                subClusters[i].properties.features[j].properties
              ) === true
            ) {
              this.openSubCluster(subClusters[i])
              i = subClusters.length + 1
              break
            }
          }
        }
      } else {
        features = this.createSpiral(
          clusterFeatures,
          openedClusterId,
          openedCluster
        )
      }
      this._geoJsonLayer.addData({
        type: 'FeatureCollection',
        features,
      })
      this.afterJsonLayerUpdated()
      this.openedClusters.push(openedClusterId)
    }
  }

  isClusterOpened(clusterId) {
    return this.openedClusters.indexOf(clusterId) > -1
  }

  isSubClusterOpened(clusterId, subClusterId) {
    return (
      this.isClusterOpened(clusterId) === true &&
      this.openedSubClusters.indexOf(subClusterId) > -1
    )
  }

  openSubCluster({
    properties: { clusterId, subClusterId, features = [] },
    geometry,
  }) {
    let points = this.createSpiral(
      features,
      clusterId,
      { geometry },
      { subClusterId }
    )
    this._geoJsonLayer.addData({
      type: 'FeatureCollection',
      features: points,
    })
    this.openedSubClusters.push(subClusterId)
  }

  closeSubCluster({ properties: { subClusterId } }, withRemove = true) {
    this.openedSubClusters = this.openedSubClusters.filter(
      (v) => v !== subClusterId
    )
    if (withRemove === true) {
      this._geoJsonLayer.eachLayer((layer) => {
        if (
          !layer.feature.properties.cluster &&
          layer.feature.properties.subClusterId === subClusterId
        ) {
          // detect spider leg
          if (layer.feature.geometry.type === 'LineString') {
            // remove spider leg only for that subcluster
            // and don't remove legs in cluster
            if (layer.feature.properties.subGroupId) {
              this._geoJsonLayer.removeLayer(layer)
            }
          } else {
            this._geoJsonLayer.removeLayer(layer)
          }
        }
      })
      this.afterJsonLayerUpdated()
    }
  }

  closeCluster(clusterId, withRemove = true) {
    this.openedClusters = this.openedClusters.filter((v) => v !== clusterId)
    if (withRemove === true) {
      this._geoJsonLayer.eachLayer((layer) => {
        if (layer.feature.properties.clusterId === clusterId) {
          this._geoJsonLayer.removeLayer(layer)
        }
      })
      this.afterJsonLayerUpdated()
    }
  }

  // TODO решить проблему с layerPointToLatLng
  createSpiral(features, clusterId, cluster, additionalProperties = {}) {
    let {
      spiralLengthFactor = 5,
      spiderfyDistanceMultiplier = 0.8,
      spiralFootSeparation = 28,
      subClusterId,
      spiralLengthStart = 11,
    } = additionalProperties
    let newFeatures = []
    let immCenter = []
    let center = {}
    let centerPt = {}
    let dep = 0
    if (cluster && cluster.geometry) {
      if (cluster.geometry.coordinates[0] > 85.0511287798066) {
        dep = cluster.geometry.coordinates[0] - 85.0511287798066
      }
      immCenter = [
        cluster.geometry.coordinates[0],
        cluster.geometry.coordinates[1],
      ]
      center = L.latLng(immCenter)
      centerPt = this._map.latLngToLayerPoint(center)
    } else {
      immCenter = [
        features[0].geometry.coordinates[0],
        features[0].geometry.coordinates[1],
      ]
      center = L.latLng(immCenter)
      centerPt = this._map.latLngToLayerPoint(center)
    }

    // TODO решить проблему с layerPointToLatLng
    let k = REGION_CONFIG.superClusterMapSpiralCoef.k

    spiralLengthFactor =
      REGION_CONFIG.superClusterMapSpiralCoef.spiralLengthFactor
    isDebug === true &&
      console.info(
        'k, spiralLengthFactor, immCenter',
        k,
        spiralLengthFactor,
        immCenter[0]
      )
    isDebug === true && createDevBlock()

    let pi2 = Math.PI * 2
    let count = features.length
    let legLength = spiderfyDistanceMultiplier * spiralLengthStart
    let separation = spiderfyDistanceMultiplier * spiralFootSeparation
    let lengthFactor = spiderfyDistanceMultiplier * spiralLengthFactor * pi2
    let angle = 0
    let i
    let p
    let coords
    let feat
    // Higher index, closer position to cluster center.
    for (i = count; i >= 0; i--) {
      // Skip the first position, so that we are already farther from center and we avoid
      // being under the default cluster icon (especially important for Circle Markers).
      if (i < count) {
        p = new L.Point(
          centerPt.x + legLength * Math.cos(angle),
          centerPt.y + legLength * k * Math.sin(angle)
        )._round()
        coords = this._map.layerPointToLatLng(p)
        coords.lat = coords.lat + dep
        isDebug === true && putPointToBlock(i, p.x, p.y, coords)
        feat = features[i]
        feat.properties.subClusterId =
          subClusterId || feat.properties.subClusterId
        feat.properties.clusterId = clusterId
        feat.geometry.coordinates = [coords.lat, coords.lng]
        // added only not exist features
        let id = getFeatureId(feat)
        if (!this._hashMap[id]) {
          newFeatures.push(feat)
          newFeatures.push({
            type: 'Feature',
            properties: {
              subClusterId: subClusterId || feat.properties.subClusterId,
              clusterId,
              id: 'leg_' + feat.properties.id,
              subGroupId: feat.properties.subGroupId,
            },
            geometry: {
              type: 'LineString',
              coordinates: [[coords.lat, coords.lng], immCenter],
            },
          })
        }
      }
      angle += separation / legLength + i * 0.0005
      legLength += lengthFactor / angle
    }
    return newFeatures
  }

  createGeoJsonLayer() {
    this._geoJsonLayer = L.geoJson(null, {
      pointToLayer: (feature, latlng) =>
        this.createClusterIcon(feature, latlng),
      style: {
        weight: 1,
        color: '#707070',
      },
    }).addTo(this._map)

    this._geoJsonLayer.on('click', (e) => {
      if (e.layer.feature.properties.subCluster) {
        let clusterId = e.layer.feature.properties.cluster_id
        let subClusterId = e.layer.feature.properties.subClusterId
        if (this.isSubClusterOpened(clusterId, subClusterId) === true) {
          this.closeSubCluster(e.layer.feature)
        } else {
          this.openSubCluster(e.layer.feature)
        }
      } else if (e.layer.feature.properties.cluster_id) {
        let clusterId = e.layer.feature.properties.cluster_id
        if (this.isMaxMapZoom() === true) {
          if (this.isClusterOpened(clusterId) === false) {
            this.sendMessage(GET_CLUSTER_POINTS, {
              clusterId,
              openedCluster: e.layer.feature,
            })
          } else {
            this.closeCluster(clusterId)
          }
        } else {
          this.sendMessage(EXPANSION_ZOOM, {
            clusterId,
            latlng: e.latlng,
            openedCluster: e.layer.feature,
          })
        }
      } else if (e.layer.feature) {
        this.bindPopup(e.layer)
      }
    })
    this._geoJsonLayer.on('layerremove ', (e) => {
      let clusterId = e.layer.feature.properties.cluster_id
      if (this.isClusterOpened(clusterId) === true) {
        this.closeCluster(clusterId, false)
      }
    })
  }

  getMarkerOfCluster(feature, latlng) {
    return L.marker(latlng, {
      icon: L.divIcon({
        className: this.layerConfig.className,
        html: feature.properties.point_count, // количество кластеров в маркере
        iconSize: feature.properties.point_count >= 10000 ? [54, 36] : [36, 36],
        iconAnchor: [18, 18],
      }),
    })
  }

  getMarker(feature, latlng) {
    return L.marker(latlng, {
      icon: this.getMarkerIcon(
        feature.properties.iconType,
        feature.properties.subIconType,
        feature.properties
      ),
      ...(feature?.properties?.id && {
        contextmenu: true,
        contextmenuItems: [
          {
            text: 'Скопировать ссылку',
            callback: () =>
              Vue.prototype.$emitter.emit('copyObjectCardLinkToClipboard', {
                id: feature.properties.id,
                subLayerConfig:
                  this.groups[feature.properties.subGroupId].subLayerConfig,
              }),
          },
        ],
      }),
    })
  }

  getMarkerIcon(iconType, subIconType, model) {
    return this.markerCreator.createIconObject(iconType, subIconType, model)
  }

  createClusterIcon(feature, latlng) {
    if (!feature.properties.cluster) return this.getMarker(feature, latlng)

    return this.getMarkerOfCluster(feature, latlng)
  }

  reCreateClaster(clusterEnabled) {
    if (this.hasShown() === true) {
      this.workerDataLoaded = false
      this.divideLowLevelDangerWaste()
      this.sendMessage(LOAD_ACTION, {
        data: this._data,
        status: this.vm.status,
        groups: deepCopy(this.groups),
        showed: this.getShowed(),
        maxMarkersInClusterOnOnePoint: this.maxMarkersInClusterOnOnePoint,
        clusterEnabled,
        zoom: this._map._zoom,
      })
    }
    this.removeUnusedGeoJsonLayer()
  }

  divideLowLevelDangerWaste() {
    this._data['accumulator'] = []
    this._data['msn-mercurial'] = []
    const dangerGroupData = this._data[LOW_LEVEL_DANGER_WASTE_KEY] || []
    dangerGroupData.forEach((item) => {
      item.recyclable_types &&
        item.recyclable_types.forEach((el) => {
          if (el === MSN_TYPES.accumulator) {
            item.type_code = 'accumulator'
            this._data['accumulator'].push(item)
          }
          if (el === MSN_TYPES.mercurial) {
            item.type_code = 'msn-mercurial'
            this._data['msn-mercurial'].push(item)
          }
        })
    })
    this._data['low_level_danger_waste'] = [...dangerGroupData]
  }

  removeUnusedGeoJsonLayer() {
    let showed = this.getShowed()
    const deleteAllLayersGroup = ['gs', 'msn']
    this._geoJsonLayer.eachLayer((layer) => {
      if (showed.indexOf(layer.feature.properties.subGroupId) === -1) {
        this._geoJsonLayer.removeLayer(layer)
      } else if (
        this._map._zoom <= MAP_GRID &&
        deleteAllLayersGroup.includes(this.checkbox)
      ) {
        this._geoJsonLayer.removeLayer(layer) //удаляем все слои для обновления данных в кластерах
      }
    })
    this.afterJsonLayerUpdated()
  }

  getShowed() {
    let showed = []
    for (let id in this._data) {
      if (!this._layers[id]) {
        continue
      }
      if (this._layers[id].shown !== true) {
        continue
      }
      showed.push(id)
    }
    return showed.sort()
  }

  bindPopup(marker) {
    if (!marker._popup) {
      let subLayerConfig =
        this.groups[marker.feature.properties.subGroupId].subLayerConfig
      let layerConfig =
        this.groups[marker.feature.properties.subGroupId].layerConfig
      let id = marker.feature.properties.id
      let popup = this.popupCreator.getPopup(marker, 'default', id, {
        autoPan: true,
        layerConfig,
        subLayerConfig,
        id,
      })
      marker.bindPopup(popup).openPopup()
    }
    this.vm.registerOpenPopup(marker.feature.properties)
  }

  recaclData() {
    if (!this.workerDataLoaded) {
      return
    }
    let bounds = this._map.getBounds()
    let bbox = [
      bounds.getWest(),
      bounds.getSouth(),
      bounds.getEast(),
      bounds.getNorth(),
    ]
    let showed = this.getShowed()
    let zoom = this._map.getZoom()
    let openedMarkerInfo = this.getOpenedMarkerInfo()
    this.sendMessage(CALC_ACTION, {
      bbox,
      zoom,
      showed,
      openedMarkerInfo,
    })
  }

  getOpenedMarkerInfo() {
    return this.vm.getOpenedMarkerInfo()
  }

  afterJsonLayerUpdated() {
    this._hashMap = {}
    if (!this._geoJsonLayer) {
      return
    }
    let popupFound = false
    this._geoJsonLayer.eachLayer((layer) => {
      let id = getFeatureId(layer.feature)
      this._hashMap[id] = true
      if (
        popupFound === false &&
        this.popupIsOpened(layer.feature.properties)
      ) {
        popupFound = true
        this.bindPopup(layer)
      }
      // marker always on top
      if (layer.feature.properties.cluster_id && layer?._icon) {
        layer._icon.style.zIndex = 0
      }
    })
  }

  popupIsOpened(markerInfo) {
    return this.vm.popupIsOpened(markerInfo)
  }

  updateJsonLayer(features) {
    if (!this._geoJsonLayer) {
      return
    }
    if (!this._hashMap) {
      this._geoJsonLayer.addData(features)
      this.afterJsonLayerUpdated()
      return
    }
    let updatedHashMap = {}
    let newFeatures = []

    features.forEach((feature) => {
      let id = getFeatureId(feature)
      // updatedHashMap[id] = true // отключила формирование _hashMap с предыидущими точками на карте
      if (!this._hashMap.hasOwnProperty(id)) {
        newFeatures.push(feature)
      }
    })

    // remove unused
    let currentZoom = this._map.getZoom()
    this.prevZoom = this.prevZoom || this._map.getZoom()
    this._geoJsonLayer.eachLayer((layer) => {
      let id = getFeatureId(layer.feature)
      let dontRemoveOnMove =
        currentZoom === this.prevZoom &&
        layer.feature?.properties?.dontRemoveOnMove

      // фильтр по статусу status status_id filter
      if (
        this.vm.status?.length &&
        !this.vm.status.includes(
          layer?.feature?.properties?.status_id?.toString()
        )
      ) {
        this._geoJsonLayer.removeLayer(layer)
      } else if (
        !updatedHashMap.hasOwnProperty(id) &&
        dontRemoveOnMove === false
      ) {
        this._geoJsonLayer.removeLayer(layer)
      }
    })
    this.prevZoom = this._map.getZoom()
    this._geoJsonLayer.addData(newFeatures)
    this.afterJsonLayerUpdated()
  }

  createSubgroups(config) {
    for (let i in config.groups) {
      let item = config.groups[i]
      if (
        config.checkbox === 'msn' &&
        i === LOW_LEVEL_DANGER_WASTE_KEY &&
        REGION_CONFIG.hasDivideLowLevelDangerWaste
      ) {
        i = 'low_level_danger_waste'
      }
      this._layers[i] = {
        shown: false,
        _data: [],
        checkbox: item.checkbox,
      }
    }
    this._layers['accumulator'] = {
      shown: false,
      _data: [],
      checkbox: 'accumulator',
    }
    this._layers['msn-mercurial'] = {
      shown: false,
      _data: [],
      checkbox: 'msn-mercurial',
    }
  }

  redraw(clusterEnabled) {
    this.reCreateClaster(clusterEnabled)
  }

  delayRedraw(clusterEnabled) {
    if (this.redrawTimeout) {
      clearTimeout(this.redrawTimeout)
      this.redrawTimeout = null
    }
    this.redrawTimeout = setTimeout(() => {
      this.redraw(clusterEnabled)
    }, 100)
  }

  showLayer(id, clusterEnabled) {
    this._layers[id].shown = true
    this.delayRedraw(clusterEnabled)
  }

  hideLayer(id, clusterEnabled) {
    this._layers[id].shown = false
    this.delayRedraw(clusterEnabled)
  }

  hasShown() {
    let hasShown = false
    for (let id in this._layers) {
      if (this._layers[id].shown === true) {
        hasShown = true
        break
      }
    }
    return hasShown
  }

  remove() {
    this.sendMessage(PURGE_CACHE)
    this._geoJsonLayer.remove()
    this._geoJsonLayer = null
    this.openedClusters = []
  }
}

export default ObjectsSupeclasterGroup
